﻿'use strict';

angular.module('ntmApp').directive('ngDropdownMultiselect', ['$filter', '$document',
    function ($filter, $document) {

        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                events: '=',
                searchFilter: '=?',
                translationTexts: '=',
                groupBy: '@'
            },
            template: function (element, attrs) {
                var checkboxes = attrs.checkboxes === true || attrs.checkboxes === 'true' ? true : false;

                var template = '<div class="multiselect-parent btn-group dropdown-multiselect"  ng-class="{\'dropup\': isPageBottom()}">';
                template += '<button type="button" title="{{getTitleText()}}" class="dropdown-toggle truncated" ng-class="settings.buttonClasses" ng-click="toggleDropdown()"><truncated-item-tooltip item-to-truncate="getButtonText()"></truncated-item-tooltip>&nbsp;<span class="caret"></span></button>';
                template += '<ul class="dropdown-menu dropdown-menu-form" ng-click="$event.stopPropagation()" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: scroll" >';
                template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a ng-keydown="keyDownLink($event)" tabindex="-1" id="selectAll" data-ng-click="selectAll()"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
                template += '<li ng-show="settings.showUncheckAll"><a ng-keydown="keyDownLink($event)" tabindex="-1" id="deselectAll" data-ng-click="deselectAll();"><span class="glyphicon glyphicon-remove"></span>   {{texts.uncheckAll}}</a></li>';
                template += '<li ng-hide="(!settings.showCheckAll || settings.selectionLimit > 0) && !settings.showUncheckAll" class="divider"></li>';
                template += '<li ng-show="settings.enableSearch"><div class="dropdown-header"><input ng-keydown="keyDownLink($event)" tabindex="-1" id="searchInput" type="text" class="form-control" style="width: 100%;" ng-model="searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
                template += '<li ng-show="settings.enableSearch" id="divider" class="divider"></li>';
                
                //with grouping
                template += '<li ng-if="groupBy && groupBy !== \'false\'" ng-repeat="group in orderedItems" ng-show="showGroupHeader(group)" role="presentation"><a id="group" class="dropdown-header" ng-keydown="keyDownLink($event)" tabindex="-1" data-ng-click="selectCurrentGroup(option[settings.groupBy])">{{ group.key }}</a>';
                template += '<ul class="grouping-list-container"><li ng-class="{\'active\' : isChecked(getPropertyForObject(option,settings.idProp))}" role="presentation" ng-repeat="option in group.items | filter: filterFunction | orderBy: [\'isChecked\', \'value\']">';
                template += '<a ng-keydown="keyDownLink($event)" role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp)); option.isChecked = !option.isChecked">';
                if (checkboxes) {
                    template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> {{getPropertyForObject(option, settings.displayProp)}}</label></div></a>';
                } else {
                    template += '<img ng-if="isChecked(getPropertyForObject(option,settings.idProp))" src="assets/images/check.png"/> {{getPropertyForObject(option, settings.displayProp)}}</a>';
                }
                template += '</li></ul></li>';
                
                //without grouping
                template += '<li ng-class="{\'active\' : isChecked(getPropertyForObject(option,settings.idProp))}" ng-if="!groupBy || groupBy === \'false\'" role="presentation" ng-repeat="option in options | filter: filterFunction | orderBy: [\'isChecked\', \'value\']">';
                template += '<a ng-keydown="keyDownLink($event)" role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp)); option.isChecked = !option.isChecked">';
                if (checkboxes) {
                    template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> {{getPropertyForObject(option, settings.displayProp)}}</label></div></a>';
                } else {
                    template += '<img ng-if="isChecked(getPropertyForObject(option,settings.idProp))" src="assets/images/check.png"/> {{getPropertyForObject(option, settings.displayProp)}}</a>';
                }
                template += '</li>';
                

                template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
                template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                template += '</ul>';
                template += '</div>';

                element.html(template);
            },
            link: function ($scope, $element, $attrs) {
                var $dropdownTrigger = $element.children()[0];

                if (angular.isString($scope.selectedModel)) {
                    var values = $scope.selectedModel.split(";");

                    $scope.selectedModel = [];
                    values.forEach(function (value) {
                        $scope.selectedModel.push({ id: value, value: value });
                    });

                } else if (!angular.isArray($scope.selectedModel)) {
                    $scope.selectedModel = [];
                }  


                $scope.checkboxes = $attrs.checkboxes === true || $attrs.checkboxes ? true : false;
                $scope.groups = $attrs.groupBy && $attrs.groupBy !== 'false' ? true : false;

                $scope.toggleDropdown = function () {
                    $scope.open = !$scope.open;
                };

                $scope.isPageBottom = function(){
                    return document.querySelector('.ui-grid .dropdown-multiselect') && angular.element(document.querySelector('.ui-grid .dropdown-multiselect')).prop('offsetTop') > 220;
                };

                $scope.checkboxClick = function ($event, id) {
                    $scope.setSelectedItem(id);
                    $event.stopImmediatePropagation();
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    dynamicButtonTitle: false,
                    scrollable: false,
                    scrollableHeight: '300px',
                    closeOnBlur: true,
                    displayProp: 'value',
                    attachDisplayProp: false,
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: 0,
                    showCheckAll: true,
                    showUncheckAll: true,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-default',
                    closeOnDeselect: false,
                    groupBy: $attrs.groupBy || undefined,
                    allowSelectionByGroups: false,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop,
                    keyboardControls: true
                };

                $scope.texts = {
                    checkAll: 'Check All',
                    uncheckAll: 'Uncheck All',
                    selectionCount: 'checked',
                    selectionOf: '/',
                    searchPlaceholder: 'Search...',
                    buttonDefaultText: 'Select',
                    dynamicButtonTextSuffix: 'checked'
                };

                $scope.searchFilter = $scope.searchFilter || '';

                if (angular.isDefined($scope.settings.groupBy) && $scope.settings.groupBy !== 'false') {
                    $scope.$watch('options', function (newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy).groupBy($scope.settings.groupBy);
                            $scope.orderedItems.forEach(function (item) {
                                if (!item.key) {
                                    item.key = 'Others';
                                }
                            });
                        }
                    });
                }

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);

                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }

                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                $scope.showGroupHeader = function (group) {
                    return group.items.length > 0 && 
                        (!$scope.searchFilter || group.key.toLowerCase().indexOf($scope.searchFilter.toLowerCase()) !== -1 ||
                        group.items.filter(function (item) { return item.value.toLowerCase().indexOf($scope.searchFilter.toLowerCase()) !== -1; }).length > 0);
                };

                $scope.keyDownLink = function (event) {
                    const sourceScope = angular.element(event.target).scope();
                    let nextOption;
                    let parent = event.target.parentNode;
                    if (!$scope.settings.keyboardControls) {
                        return;
                    }
                    if ((event.keyCode === 13 || event.keyCode === 32)) { // enter
                        if (sourceScope.option) {
                            event.preventDefault();
                            if (event.target.id !== 'group') {
                                $scope.setSelectedItem($scope.getPropertyForObject(sourceScope.option, $scope.settings.idProp));
                            } else {
                                $scope.selectCurrentGroup(sourceScope.option[$scope.settings.groupBy]);
                            }
                        } else if (event.target.id === 'deselectAll') {
                            event.preventDefault();
                            $scope.deselectAll();
                        } else if (event.target.id === 'selectAll') {
                            event.preventDefault();
                            $scope.selectAll();
                        }
                    } else if (event.keyCode === 38) { // up arrow
                        event.preventDefault();
                        if (parent.previousElementSibling) {
                            nextOption = parent.previousElementSibling.querySelector('a') || parent.previousElementSibling.querySelector('input');
                        }
                        else if (event.target.id === 'searchInput') {
                            parent = parent.parentElement;
                        }
                        while (!nextOption && !!parent) {
                            parent = parent.previousElementSibling;
                            if (parent) {
                                nextOption = parent.querySelector('a') || parent.querySelector('input');
                            }
                        }
                        if (nextOption) {
                            nextOption.focus();
                        }
                    } else if (event.keyCode === 40) { // down arrow
                        event.preventDefault();
                        if (parent.nextElementSibling) {
                            nextOption = parent.nextElementSibling.querySelector('a') || parent.nextElementSibling.querySelector('input');
                        }
                        else if (event.target.id === 'searchInput') {
                            parent = parent.parentElement;
                        }
                        while (!nextOption && !!parent) {
                            parent = parent.nextElementSibling;
                            if (parent) {
                                nextOption = parent.querySelector('a') || parent.querySelector('input');
                            }
                        }
                        if (nextOption) {
                            nextOption.focus();
                        }
                    } else if (event.keyCode === 27) { // esc
                        event.preventDefault();

                        $scope.toggleDropdown();
                    }
                };

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }

                if ($scope.settings.closeOnBlur) {
                    $document.on('click', function (e) {
                        var target = e.target.parentElement;
                        var parentFound = false;

                        while (angular.isDefined(target) && target !== null && !parentFound) {
                            if (_us.contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                                if (target === $dropdownTrigger) {
                                    parentFound = true;
                                }
                            }
                            target = target.parentElement;
                        }

                        if (!parentFound) {
                            $scope.$apply(function () {
                                $scope.open = false;
                            });
                        }
                    });
                }

                $scope.getGroupTitle = function (groupValue) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue) || 'Others';
                    }

                    return groupValue || 'Others';
                };

                $scope.getButtonText = function () {
                    if ($scope.settings.dynamicTitle && $scope.selectedModel && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _us.keys($scope.selectedModel).length > 0))) {
                        if ($scope.settings.smartButtonMaxItems > 0) {
                            var itemsText = [];

                            angular.forEach($scope.options, function (optionItem) {
                                if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                    itemsText.push(converterResponse ? converterResponse : displayText);
                                }
                            });

                            if ($scope.settings.dynamicButtonTitle) {
                                $dropdownTrigger.children[0].title = itemsText.join('; ');
                            }

                            if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                itemsText.push('...');
                            }

                            return itemsText.join('; ');
                        } else {
                            var totalSelected;

                            if ($scope.singleSelection) {
                                totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                            } else {
                                totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                            }

                            if (totalSelected === 0) {
                                return $scope.texts.buttonDefaultText;
                            } else {
                                return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                            }
                        }
                    } else {
                        return $scope.texts.buttonDefaultText;
                    }
                };

                $scope.getTitleText = function () {
                    if ($scope.selectedModel && $scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                        var itemsText = [];

                        angular.forEach($scope.options, function (optionItem) {
                            if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                itemsText.push(converterResponse ? converterResponse : displayText);
                            }
                        });

                        if ($scope.settings.dynamicButtonTitle) {
                            $dropdownTrigger.children[0].title = itemsText.join('; ');
                        }

                        return itemsText.join('; ');
                    }
                };

                $scope.getPropertyForObject = function (object, property) {
                    if (property === 'value' && object && object.value === '') {
                        return 'Blank';
                    }

                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        return object[property];
                    }

                    return '';
                };

                $scope.selectAll = function () {
                    $scope.selectedModel = $scope.selectedModel || [];

                    $scope.deselectAll(false);
                    $scope.externalEvents.onSelectAll();

                    angular.forEach($scope.options, function (value) {
                        $scope.setSelectedItem(value[$scope.settings.idProp], true);
                    });
                };

                $scope.deselectAll = function (sendEvent) {
                    sendEvent = sendEvent || true;

                    $scope.selectedModel = $scope.selectedModel || [];

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                    } else {
                        $scope.selectedModel.splice(0, $scope.selectedModel.length);
                    }

                    if (sendEvent) {
                        $scope.externalEvents.onDeselectAll();
                    }
                };

                $scope.selectCurrentGroup = function (groupValue) {
                    if ($scope.settings.allowSelectionByGroups) {
                        $scope.deselectAll(false);

                        angular.forEach($scope.options, function (value) {
                            if (value[$scope.groupBy] === groupValue) {
                                $scope.setSelectedItem(value[$scope.settings.idProp], true);
                            }
                        });
                    }
                };

                $scope.setSelectedItem = function (id, dontRemove) {
                    var findObj = getFindObj(id);
                    var finalObj = null;

                    if ($scope.settings.externalIdProp === '') {
                        finalObj = _us.find($scope.options, findObj);
                    } else {
                        finalObj = findObj;
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                        angular.extend($scope.selectedModel, finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);

                        return;
                    }

                    dontRemove = dontRemove || false;

                    var exists = _us.findIndex($scope.selectedModel, findObj) !== -1;

                    if (!dontRemove && exists) {
                        $scope.selectedModel.splice(_us.findIndex($scope.selectedModel, findObj), 1);
                        $scope.externalEvents.onItemDeselect(findObj);
                    } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {

                        if ($scope.settings.attachDisplayProp) {
                            var idProp = $scope.settings.externalIdProp === '' ? $scope.settings.idProp : $scope.settings.externalIdProp;
                            var option = $scope.options.firstOrDefault(function (item) {
                                return item[idProp] === findObj[idProp];
                            });

                            if (option) {
                                finalObj[$scope.settings.displayProp] = option[$scope.settings.displayProp];
                            }
                        }

                        if (!$scope.selectedModel) {
                            $scope.selectedModel = [];
                        }

                        $scope.selectedModel.push(finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);
                    }
                };

                $scope.isChecked = function (id) {
                    if ($scope.singleSelection) {
                        return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                    }

                    return _us.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                };

                $scope.orderFunction = function(option) {
                    return !$scope.isChecked($scope.getPropertyForObject(option, $scope.settings.idProp));
                };

                $scope.filterFunction = function (option) {
                    if (!$scope.searchFilter || (option.value && option.value.toLowerCase().indexOf($scope.searchFilter.toLowerCase()) !== -1) || (option.groupBy && option.groupBy.toLowerCase().indexOf($scope.searchFilter.toLowerCase()) !== -1)) {
                        return true;
                    }
                    return false;
                };

                $scope.externalEvents.onInitDone();
            }
        };
    }]);
